import { Flex, Skeleton, Typography } from 'antd';
import { useSearchPromptTemplatesInfiniteQuery } from '../../../../store/stylist/stylistApi';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectPromptTemplateFilters,
  addPromptTemplateFilter,
} from '../../../../store/stylist/slice';
import ActiveFiltersBar from './ActiveFiltersBar';
import FacetDropdown from '../../../Products/Discovery/Filters/FacetDropdown';
import * as Styles from './styles';

interface IFiltersProps {
  showTitle?: boolean;
  selectSize?: SizeType;
}

const STATUS_FACET = {
  key: { key: 'is_active', displayName: 'Status' },
  values: [
    { id: 'true', value: 'Active' },
    { id: 'false', value: 'Inactive' },
  ],
};

const Filters = ({ showTitle = true, selectSize = 'middle' }: IFiltersProps) => {
  const dispatch = useAppDispatch();
  const activeFilters = useAppSelector(selectPromptTemplateFilters);

  const { isLoading } = useSearchPromptTemplatesInfiniteQuery({
    filters: activeFilters,
  });

  const getSelectedValues = (fieldName: string): Array<string> => {
    const filter = activeFilters.find(f => f.field === fieldName);
    return filter ? [filter.value] : [];
  };

  const handleFilterChange = (fieldName: string, values: Array<string>, filterType?: string) => {
    if (values.length > 0) {
      dispatch(
        addPromptTemplateFilter({
          field: fieldName,
          value: values[0],
          filterType: filterType || 'EQ',
        }),
      );
    }
  };

  return (
    <Styles.Wrapper>
      {showTitle && (
        <Typography.Paragraph strong={true}>Prompt Template Filters</Typography.Paragraph>
      )}
      <Flex gap="middle" wrap>
        <FacetDropdown
          facet={STATUS_FACET}
          selectedValues={getSelectedValues('is_active')}
          onChange={values => handleFilterChange('is_active', values, 'EQ')}
          size={selectSize}
        />
        {isLoading &&
          Array.from({ length: 3 }).map((_, i) => (
            <Skeleton.Button
              key={i}
              active
              size="small"
              shape="round"
              style={{ width: 150, height: 32 }}
            />
          ))}
      </Flex>
      <ActiveFiltersBar />
    </Styles.Wrapper>
  );
};

export default Filters;
